import addIssueType from '@qality/common-static/images/addIssueType.png';
import addTestCase from '@qality/common-static/images/addTestCase.png';
import executeTestCase from '@qality/common-static/images/executeTestCase.png';
import folder from '@qality/common-static/images/folder.png';
import manageInTestCycle from '@qality/common-static/images/manageInTestCycle.png';
import permissions from '@qality/common-static/images/permissions.png';
import reporting from '@qality/common-static/images/reporting.png';
import testCaseRepository from '@qality/common-static/images/testCaseRepository.png';

export default {
  getAddIssueTypePath(): string {
    return addIssueType;
  },

  getAddTestCasePath(): string {
    return addTestCase;
  },

  getExecuteTestCasePath(): string {
    return executeTestCase;
  },

  getManageInTestCyclePath(): string {
    return manageInTestCycle;
  },

  getReportingPath(): string {
    return reporting;
  },

  getTestCaseRepositoryPath(): string {
    return testCaseRepository;
  },

  getFolder(): string {
    return folder;
  },

  getPermissions(): string {
    return permissions;
  },
};
